// hooks/useAntifraudMethods.js
import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/**
 * Hook para Métodos de Antifraude
 * - Suporta responses:
 *   A) { data: [...], pagination: {...} }
 *   B) { data: { data: [...], pagination: {...} } }
 */
export const useAntifraudMethods = (page = 1, limit = 10, search = "") => {
  const qc = useQueryClient();

  const query = useQuery(
    ["antifraudMethods", page, limit, search],
    () =>
      fetchData(
        `/antifraud-methods?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`
      ),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (resp) => {
        // resp pode ser:
        //  - { data: [...], pagination: {...} }
        //  - { message, data: { data: [...], pagination: {...} } }
        const defPagination = { total: 0, page, limit };

        const wrapped =
          resp?.data &&
          (Array.isArray(resp?.data?.data) || resp?.data?.pagination);

        const list = wrapped
          ? resp.data.data || []
          : Array.isArray(resp?.data)
          ? resp.data
          : [];

        const pagination = wrapped
          ? resp.data.pagination || defPagination
          : resp?.pagination || defPagination;

        return { data: list, pagination };
      },
    }
  );

  // Create / Update
  const updateMutation = useMutation(
    (method) => {
      const endpoint = method?.id
        ? `/antifraud-methods/${method.id}`
        : `/antifraud-methods`;
      const methodType = method?.id ? "PUT" : "POST";
      return fetchData(endpoint, methodType, method);
    },
    {
      onSuccess: () => qc.invalidateQueries("antifraudMethods"),
    }
  );

  // Toggle status (PUT parcial)
  const updateStatusMutation = useMutation(
    ({ id, status }) =>
      fetchData(`/antifraud-methods/${id}`, "PUT", { status }),
    {
      onSuccess: () => qc.invalidateQueries("antifraudMethods"),
    }
  );

  // Delete (soft delete)
  const deleteMutation = useMutation(
    (id) => fetchData(`/antifraud-methods/${id}`, "DELETE"),
    {
      onSuccess: () => qc.invalidateQueries("antifraudMethods"),
    }
  );

  return { ...query, updateMutation, updateStatusMutation, deleteMutation };
};
